angular
    .module('WizApp')
    .factory('TrackerService', [
        '$http',
        '$filter',
        function ($http, $filter) {
            const route = $filter('route');
            const adEndpoint = route('wizbii_pub_ui_tracking');

            return function (data) {
                if (data.$domEvent === 'view' && data.event === 'Publication') {
                    const url = route('wizbii_publicationui_registerview', {
                        id: data.label
                    });

                    $http.post(url);
                    return;
                }

                if (data.$adId) {
                    const ad_id = data.$adId;
                    const domEvent = data.$domEvent;

                    const mapping = {
                        load: 'view',
                        click: 'clicked'
                    };

                    const action =
                        mapping.hasOwnProperty(domEvent)
                            ? mapping[domEvent]
                            : domEvent
                        ;

                    $http.post(adEndpoint, { ad_id, action });
                }
            };
        }
    ])
;
